



































import { ElTable } from "element-ui/types/table";
import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system";
import { IDocumentAlert } from "../../../../../domain/document";
import { EditingDocument } from "../../../../../applications/documaker/components/document/editor";

@Component
export default class AlertList extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  $refs!: {
    table: ElTable,
  };

  get alerts(): IDocumentAlert[] {
    return this.readPropertyOrDefault(s => s.alerts, []);
  }

  activated() {
    this.refreshTableLayout();
  }

  click(row: IDocumentAlert) {
    if (row.itemSetId == null || !row.detectedItem) { return; }
    this.editingSource.updateFocusedItem(row.itemSetId, row.detectedItem);
  }

  private refreshTableLayout(): void {
    this.$doWhenValid(t => t.doLayout(), this.$refs.table);
  }
}
